import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA Enterprise) — attests the admin panel and the public
// signup/renew pages to Firebase so Cloud Functions (enforceAppCheck) and
// console-enforced Firestore/Storage accept their requests, while bots are
// rejected. Provide the site key via REACT_APP_RECAPTCHA_SITE_KEY; in local
// dev set window.FIREBASE_APPCHECK_DEBUG_TOKEN before load to get a debug token.
//
// App Check state is per-FirebaseApp. Every service used by the public pages
// must therefore hang off THIS app — a second `initializeApp(config, 'public')`
// instance would carry no App Check token, so the moment Storage enforcement is
// switched on in the console its uploads start failing with a 403 the SDK
// surfaces as `storage/unauthorized`. Public pages are unauthenticated, not
// un-attested: they share the default app and simply never sign anyone in.
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
